import { useApolloClient, useMutation } from "@apollo/client/react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "@/app/hooks";
import { removeAuthorizationToken, setAuthorizationCookie, setAuthorizationToken } from "@/authorizationToken";
import { LoginDocument, SessionDataDocument } from "@/gql/graphql";
import { setSession } from "./sessionSlice";
export function useLogin() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const apolloClient = useApolloClient();
    const [loginMutation] = useMutation(LoginDocument);
    return async ({ email, password }) => {
        try {
            const { data } = await loginMutation({ variables: { email, password } });
            const token = data?.login;
            if (token) {
                setAuthorizationToken(token);
                setAuthorizationCookie(token);
                const { data: sessionData } = await apolloClient.query({
                    query: SessionDataDocument,
                });
                if (!sessionData?.sessionData)
                    return;
                dispatch(setSession({
                    user: sessionData.sessionData.user,
                    customer: {
                        ...sessionData.sessionData.customer,
                        attrs: sessionData.sessionData.customer.attrs,
                    },
                    token,
                    loading: false,
                }));
                navigate("/dashboard");
            }
        }
        catch (error) {
            console.log(error);
            removeAuthorizationToken();
        }
    };
}
